/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/mentions/index.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import * as React from 'react';
import classNames from 'classnames';
import RcMentions from 'rc-mentions';
import { composeRef } from 'rc-util/lib/ref';
import Spin from '../spin';
import { ConfigContext, withConfigProvider } from '../config-provider';
export const { Option } = RcMentions;
function loadingFilterOption() {
    return true;
}
const InternalMentions = ({ prefixCls: customizePrefixCls, className, disabled, loading, filterOption, children, notFoundContent, ...restProps }, ref) => {
    const [focused, setFocused] = React.useState(false);
    const innerRef = React.useRef();
    const mergedRef = composeRef(ref, innerRef);
    const { getPrefixCls, renderEmpty, direction } = React.useContext(ConfigContext);
    const onFocus = (...args) => {
        if (restProps.onFocus) {
            restProps.onFocus(...args);
        }
        setFocused(true);
    };
    const onBlur = (...args) => {
        if (restProps.onBlur) {
            restProps.onBlur(...args);
        }
        setFocused(false);
    };
    const getNotFoundContent = () => {
        if (notFoundContent !== undefined) {
            return notFoundContent;
        }
        return renderEmpty('Select');
    };
    const getOptions = () => {
        if (loading) {
            return (React.createElement(Option, { value: 'ANTD_SEARCHING', disabled: true },
                React.createElement(Spin, { size: 'small' })));
        }
        return children;
    };
    const getFilterOption = () => {
        if (loading) {
            return loadingFilterOption;
        }
        return filterOption;
    };
    const prefixCls = getPrefixCls('mentions', customizePrefixCls);
    const mergedClassName = classNames({
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className);
    return (React.createElement(RcMentions, { prefixCls: prefixCls, notFoundContent: getNotFoundContent(), className: mergedClassName, disabled: disabled, direction: direction, ...restProps, filterOption: getFilterOption(), onFocus: onFocus, onBlur: onBlur, ref: mergedRef }, getOptions()));
};
const Mentions = React.forwardRef(InternalMentions);
Mentions.displayName = 'Mentions';
Mentions.Option = Option;
Mentions.getMentions = (value = '', config = {}) => {
    const { prefix = '@', split = ' ' } = config;
    const prefixList = Array.isArray(prefix) ? prefix : [prefix];
    return value
        .split(split)
        .map((str = '') => {
        let hitPrefix = null;
        prefixList.some((prefixStr) => {
            const startStr = str.slice(0, prefixStr.length);
            if (startStr === prefixStr) {
                hitPrefix = prefixStr;
                return true;
            }
            return false;
        });
        if (hitPrefix !== null) {
            return {
                prefix: hitPrefix,
                value: str.slice(hitPrefix.length)
            };
        }
        return null;
    })
        .filter((entity) => !!entity && !!entity.value);
};
export default withConfigProvider(Mentions);
